import { render, staticRenderFns } from "./InactiveNotice.vue?vue&type=template&id=6170c0cb"
import script from "./InactiveNotice.vue?vue&type=script&lang=js"
export * from "./InactiveNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports